'use strict';

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var optimizeImageHoc = function optimizeImageHoc(WrappedComponent) {
  var OptimizedImage = function (_React$Component) {
    _inherits(OptimizedImage, _React$Component);

    function OptimizedImage(props) {
      _classCallCheck(this, OptimizedImage);

      var _this = _possibleConstructorReturn(this, (OptimizedImage.__proto__ || Object.getPrototypeOf(OptimizedImage)).call(this, props));

      _initialiseProps.call(_this);

      _this._isMounted = false; // retina ready images

      if (typeof window !== 'undefined' && window.devicePixelRatio >= 2) {
        _this.resolutionFactor = 4;
      } else {
        _this.resolutionFactor = 2;
      }

      var placeholder = props.placeholder;

      if (!props.placeholder) {
        placeholder = _this.calcPlaceholder(props);
      }

      var url = props.src.split('?')[0];
      var params = props.src.split('?')[1];

      var srcObject = _extends({
        h: 0,
        w: 0
      }, _queryString2['default'].parse(params));

      var updatedSrc = url + '?' + _queryString2['default'].stringify(srcObject);

      _this.state = {
        src: updatedSrc,
        placeholder: placeholder
      };

      if (!props.width && !props.height && placeholder) {
        _this.state.src = placeholder;
      }

      return _this;
    }

    _createClass(OptimizedImage, [{
      key: 'calcPlaceholder',
      value: function calcPlaceholder() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var srcObject = this.calcImageSrc(props.src);
        srcObject.q = 0;

        if (props.ratio) {
          srcObject.w = 100;
          srcObject.h = 100 / props.ratio;
        }

        var url = props.src.split('?')[0];
        return url + '?' + _queryString2['default'].stringify(srcObject);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.updateImageSrc(this.state.placeholder);
        this._isMounted = true;
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.alwaysFetch || prevProps.height < this.props.height || prevProps.src !== this.props.src) {
          this.debouncedUpdateImageSrc();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._isMounted = false;
      }
    }, {
      key: 'calcImageSrc',
      value: function calcImageSrc(src) {
        var _props = this.props,
            height = _props.height,
            width = _props.width;
        var params = src.split('?')[1];
        var sameSrc = this.state && src === this.state.src;

        var srcObject = _extends({
          h: 0,
          w: 0
        }, _queryString2['default'].parse(params));

        var nextHeight = height * this.resolutionFactor;

        if (!sameSrc || srcObject.h < nextHeight) {
          srcObject.h = nextHeight;
        }

        var nextWidth = width * this.resolutionFactor;

        if (!sameSrc || srcObject.w < nextWidth) {
          srcObject.w = nextWidth;
        }

        return srcObject;
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            src = _state.src,
            placeholder = _state.placeholder;

        var _props2 = this.props,
            fixedPlaceholder = _props2.fixedPlaceholder,
            alwaysNewPlaceholder = _props2.alwaysNewPlaceholder,
            alwaysFetch = _props2.alwaysFetch,
            rest = _objectWithoutProperties(_props2, ['fixedPlaceholder', 'alwaysNewPlaceholder', 'alwaysFetch']);

        return _react2['default'].createElement(WrappedComponent, _extends({}, rest, {
          src: src,
          placeholder: placeholder || src
        }));
      }
    }]);

    return OptimizedImage;
  }(_react2['default'].Component);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.updateImageSrc = function () {
      var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.src;
      var _props3 = _this2.props,
          src = _props3.src,
          alwaysNewPlaceholder = _props3.alwaysNewPlaceholder,
          fixedPlaceholder = _props3.fixedPlaceholder;

      var stateUrl = _this2.state.src.split('?')[0];

      var stateParams = _this2.state.src.split('?')[0];

      var stateSrcObject = _queryString2['default'].parse(stateParams);

      var url = src.split('?')[0];
      var params = src.split('?')[1];

      var srcObject = _extends({
        h: 0,
        w: 0
      }, _queryString2['default'].parse(params));

      var newSrcObject = _this2.calcImageSrc(src);

      if (!(0, _isEqual2['default'])(srcObject, newSrcObject) || stateUrl !== url) {
        var updatedSrc = _this2.state.src;

        if (newSrcObject.h && newSrcObject.w) {
          updatedSrc = url + '?' + _queryString2['default'].stringify(newSrcObject);
        }

        if (fixedPlaceholder) {
          placeholder = _this2.state.placeholder;
        } else if (alwaysNewPlaceholder || !stateSrcObject.h || !stateSrcObject.w) {
          placeholder = _this2.calcPlaceholder();
        }

        if (_this2._isMounted) {
          _this2.setState(_extends({}, _this2.state, {
            src: updatedSrc,
            placeholder: placeholder
          }), function () {
            if (_this2.props.srcChanged) {
              _this2.props.srcChanged();
            }
          });
        }
      }
    };

    this.debouncedUpdateImageSrc = (0, _debounce2['default'])(this.updateImageSrc, 300);
  };

  OptimizedImage.displayName = 'OptimizedImage(' + WrappedComponent.displayName + ')';
  OptimizedImage.propTypes = _extends({}, WrappedComponent.propTypes, {
    src: _propTypes2['default'].string,
    placeholder: _propTypes2['default'].string,
    ratio: _propTypes2['default'].number,
    fixedPlaceholder: _propTypes2['default'].bool,
    alwaysNewPlaceholder: _propTypes2['default'].bool,
    alwaysFetch: _propTypes2['default'].bool
  });
  OptimizedImage.defaultProps = _extends({}, WrappedComponent.defaultProps, {
    fixedPlaceholder: false,
    alwaysNewPlaceholder: false,
    alwaysFetch: false
  });
  return (0, _hoistNonReactStatics2['default'])(OptimizedImage, WrappedComponent);
};

exports['default'] = optimizeImageHoc;